import React from 'react';

const HighlightPhrase = ({ children, eyebrow, dark = false, testId }) => (
  <section
    className={`py-24 lg:py-32 ${dark ? 'bg-[#1E3A8A] text-white' : 'bg-ivory text-cyan-vidat'}`}
    data-testid={testId}
  >
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 text-center">
      {eyebrow && (
        <div className={`text-[11px] uppercase tracking-[0.28em] font-medium mb-8 ${dark ? 'text-white/70' : 'text-cyan-vidat'}`}>
          {eyebrow}
        </div>
      )}
      <p className={`font-display text-[clamp(1.6rem,3.4vw,2.8rem)] leading-[1.25] font-light tracking-tight ${dark ? 'text-white' : 'text-cyan-vidat'}`}>
        {children}
      </p>
    </div>
  </section>
);

export default HighlightPhrase;
